import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {AsideService} from './aside.service';
import {NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss'],
})
export class AsideComponent implements OnInit, OnDestroy{
  isInsideExamen = false;

  constructor(private asideService: AsideService, private router: Router) {
  }

  ngOnInit(): void {
    this.asideService.insideExamenSubject$.subscribe(
      (data) => (this.isInsideExamen = data)
    );
  }

  /**
   * @description retorna la ruta actual que esta en el Router
   */
  get rutaActual(): string {
    return this.router.url;
  }

  onclick(ruta: string): void {
    if (this.isInsideExamen) {
      this.asideService.openModal(ruta);
    } else {
      this.router.navigate([ruta]);
    }
  }

  ngOnDestroy(): void {
  }
}
